import { dayjsDate } from "../utils";
export const formatDate = (value, options = {
    format: 'MM/DD/YYYY'
})=>{
    if (!value) {
        return '';
    }
    const isDateOnlyFormat = options.useUtc && !/[HhmsaA]/.test(options.format || '');
    if (options.useUtc && isDateOnlyFormat) {
        const dateObj = value instanceof Date ? value : new Date(value);
        const year = dateObj.getUTCFullYear();
        const month = dateObj.getUTCMonth();
        const day = dateObj.getUTCDate();
        const noonUTC = new Date(Date.UTC(year, month, day, 12, 0, 0, 0));
        return dayjsDate.utc(noonUTC).format(options.format);
    }
    const date = options.useUtc ? dayjsDate.utc(value) : dayjsDate(value);
    return date.isValid() ? date.format(options.format) : '';
};

//# sourceMappingURL=formatDate.js.map